import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-phone',
    templateUrl: './his-display-phone.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayPhoneComponent {
    value: string;
    url: string;

    @Input( 'value' )
    set _value_( val: string ) {
        this.value = val;
        if ( !val ) {
            this.url = null;
            return;
        }
        this.url = 'tel://' + val.replace( /[ ()/-]/g, '' ).replace( /^[+]/, '00' );
    }
}
